import { DragOverlay } from "@dnd-kit/core";

import {
  MessagePathLabel,
  TopicLabel,
} from "@/shared/components/visualization/Topics/TopicTree";
import {
  type MessagePathNode,
  type TopicNode,
  TopicNode as TopicNodeClass,
} from "@/shared/domain/topics";

import { DragItem } from "../../DnD";

import { type DragOverlayProps } from "./base";
import styles from "./DragOverlays.module.css";

export function TreeNodeDragOverlay({ active }: DragOverlayProps) {
  const isTreeNode = active?.type === DragItem.TreeNode;
  const node = active?.data as TopicNode | MessagePathNode | undefined;

  if (!isTreeNode || !node) {
    return <DragOverlay className={styles.dragOverlay} dropAnimation={null} />;
  }

  const isTopic = node instanceof TopicNodeClass;

  return (
    <DragOverlay className={styles.dragOverlay} dropAnimation={null}>
      <div className={styles.treeNodeLabel}>
        {isTopic ? (
          <TopicLabel
            dataType={node.data.schema_name || ""}
            label={node.label}
          />
        ) : (
          <MessagePathLabel dataType={node.data.data_type} label={node.label} />
        )}
      </div>
    </DragOverlay>
  );
}
